export default {
    book: 'Foglalás {product}',
    age_limit: 'Csak {age} éven felülieknek',
    change_plan: 'Terv módosítása',
    upgrade_product: 'Termék frissítése',
    upgrade: 'Frissítés',
    cancel_upgrade: 'Frissítés visszavonása',
    choose_product: '{product} kiválasztása',
    days: '{count} nap | {count} nap',
    login_register: 'Bejelentkezés/Regisztráció',
    current: 'Jelenlegi',
    keyless_benefits: {
        label: 'Közvetlenül az autóhoz {0}',
        highlight: 'bérlési szolgáltatás™',
        list: {
            cant_lose_the_key: 'Teljes biztosítás',
            zero_excess: 'Önrész nélkül',
            phone_as_a_key: 'Telefon mint kulcs',
            straight_to_car: 'Nincs várakozás',
            no_queues: 'Nincsenek sorok',
            online_id_check: 'Online személyazonosítás',
            self_checkout: 'Önkiszolgáló átvétel',
        },
    },
};
